// extracted by mini-css-extract-plugin
module.exports = {"mention":"PrepopulatedMention__mention___2ULL4"};